import initCopytradingCalculator from '../initCopytradingCalculator';
import initChoicesInstance from '../initChoicesInstance';
import initAccordion from '../initAccordion';
import initSimpleParallax from '../parallax/initSimpleParallax';
import { parallaxVerticalOptions } from '../parallax/parallax';

document.addEventListener('DOMContentLoaded', (e) => {
  initCopytradingCalculator();
  initAccordion();

  const singleChoiceElement = document.querySelector('[data-single-choice]');
  const singleChoice = initChoicesInstance(singleChoiceElement);

  const parallaxVerticalCards = document.querySelectorAll('[data-parallax-vertical-card]');
  initSimpleParallax(parallaxVerticalCards, parallaxVerticalOptions);
});
